import { useCompanyCRUDActions } from '@mm/state/actions/CompanyCRUDActions';
import { useUsersCRUDActions } from '@mm/state/actions/UsersCRUDActions';
import { OnboardingSignupStep } from '@mm/state/model/CompanyUsersModel';
import {
  isFacebookUserSelector,
  selectSessionSelector,
} from '@mm/state/selectors/userSelector';
import { activeCompanySelector } from '@mm/state/selectors/viewSelectors';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import OnboardingPageLoadingIndicator from '../../common/OnboardingPageLoadingIndicator/OnboardingPageLoadingIndicator';
import { WelcomePage } from './components/WelcomePage/WelcomePage';
import './NewUserInfoFlow.scss';
import { OnboardingRoutes } from '../../../../../routes/onboarding-routes';
import { useRegisterSignupEvent } from '../../../../hooks/use-register-signup-event';
import { useHistory } from 'react-router-dom';
import { extractDomainName } from '../../../XRayOnboarding/WebsiteReportSummary/constants';
import { useGetWebsiteTraffic } from '../../../XRayOnboarding/hooks/use-get-website-traffic';

export const NewUserInfoFlow = () => {
  const activeCompany = useSelector(activeCompanySelector);
  const isFBUser = useSelector(isFacebookUserSelector);
  const { userAttributes, id: userId } = useSelector(selectSessionSelector);
  const [busy, setBusy] = useState(false);

  const { registerSignUpEventWithTracking } = useRegisterSignupEvent();
  const { update } = useCompanyCRUDActions();
  const { updateUserAttributes } = useUsersCRUDActions();
  const { retrieveTotals } = useGetWebsiteTraffic({});

  const history = useHistory();

  const registerSignUpEvent = () => {
    registerSignUpEventWithTracking({
      nextOnboardingStep: OnboardingSignupStep.NONE,
      skipRedirect: false,
      audienceExtractorChannel: isFBUser ? 'facebook' : undefined,
    });
  };

  const updateCompany = async (
    name: string,
    businessEmail: string,
    website: string,
    phoneNumber: string,
    jobRole: string,
    clientsCharge: string,
    goal: string,
  ) => {
    if (activeCompany) {
      const { id } = activeCompany;
      setBusy(true);
      await update({
        id,
        name,
        businessEmail,
        website,
        phoneNumber,
        jobRole,
        clientsCharge,
        goal,
      });
      setBusy(false);

      const domainName = extractDomainName(website);
      if (domainName) {
        setBusy(true);
        const { totals } = await retrieveTotals(domainName);

        setBusy(false);

        const isSQL = totals?.trafficTypes?.sql;

        if (isSQL) {
          await updateUserAttributes(id, userId, {
            onboardingSignupStep: OnboardingSignupStep.BOOK_DEMO,
          });
          history.push(OnboardingRoutes.bookDemo.path);
        } else {
          registerSignUpEvent();
        }
      }
    }
  };

  useEffect(() => {
    // old users who stopped on any onboarding step
    if (
      (userAttributes?.onboardingCompanyInfoStep || 0) > 1 &&
      userAttributes.onboardingSignupStep === OnboardingSignupStep.USER_INFO
    ) {
      registerSignUpEvent();
    }
  }, []);

  if (!activeCompany) {
    return null;
  }

  return (
    <div className="user-info-flow">
      <WelcomePage onStartPress={updateCompany} company={activeCompany} />
      <OnboardingPageLoadingIndicator isLoading={busy} />
    </div>
  );
};
